import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-field-quill',
  template: `
  <quill-editor
    [formControl]="formControl"
    [modules]="quillModules"
    [theme]="'snow'"
    [readOnly]="to.disabled"
  >
  </quill-editor>
  `,
  styles: []
})
export class FormlyFieldQuillComponent extends FieldType implements OnInit {
  public quillModules = {};

  ngOnInit() {
    const baseModules = this.to.quillModules || {};

    this.quillModules = {
      ...baseModules,
      clipboard: {
        ...baseModules.clipboard,
        matchVisual: false,
        matchers: [
          ...((baseModules.clipboard && baseModules.clipboard.matchers) || []),
          ['P', (node, delta) => {
            return delta.insert('\n');
          }]
        ]
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/schema-form/formly-field-quill/formly-field-quill.component.ts